import { MUSCLE_GROUP_NAMES, type MuscleGroup } from '@squats/shared';
import { MAP_LABELS, MAP_VIEW, muscleMap } from '../figures/muscle-map.ts';

/** Front and back body diagrams: main muscles in strong colour, supporting ones lighter. */
export function MuscleMap({ primary, secondary }: { primary: readonly MuscleGroup[]; secondary: readonly MuscleGroup[] }) {
  const regions = muscleMap(primary, secondary);
  const describe = (groups: readonly MuscleGroup[]) => groups.map((g) => MUSCLE_GROUP_NAMES[g]).join(', ');
  return (
    <div className="muscle-map">
      <svg viewBox={`0 0 ${MAP_VIEW.width} ${MAP_VIEW.height}`} role="img" aria-label={`Main: ${describe(primary)}. ${secondary.length ? `Also: ${describe(secondary)}.` : ''}`}>
        {regions.map((r, i) =>
          r.region.kind === 'ellipse' ? (
            <ellipse
              key={i}
              cx={r.region.cx}
              cy={r.region.cy}
              rx={r.region.rx}
              ry={r.region.ry}
              transform={r.region.rotate ? `rotate(${r.region.rotate} ${r.region.cx} ${r.region.cy})` : undefined}
              className={`map-${r.level}`}
            />
          ) : (
            <polygon key={i} points={r.region.points.map((p) => p.join(',')).join(' ')} className={`map-${r.level}`} />
          ),
        )}
        {MAP_LABELS.map((l) => (
          <text key={l.text} x={l.x} y={MAP_VIEW.height - 2} textAnchor="middle" className="map-label">
            {l.text}
          </text>
        ))}
      </svg>
      <dl className="map-legend">
        <dt>
          <span className="swatch primary" aria-hidden="true" /> Main
        </dt>
        <dd>{describe(primary)}</dd>
        {secondary.length > 0 && (
          <>
            <dt>
              <span className="swatch secondary" aria-hidden="true" /> Also
            </dt>
            <dd>{describe(secondary)}</dd>
          </>
        )}
      </dl>
      {primary.includes('cardio') && <p className="muted small">Cardio: works your heart and lungs as well as the muscles shown.</p>}
    </div>
  );
}
